/** @license See the LICENSE file. */
// This code is auto-generated, do not modify this file!
const version = '2.8.6';
export { version };
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@tensorflow/tfjs-data/dist/version.js
// module id = 1614
// module chunks = 0